// extracted by mini-css-extract-plugin
export default {"container":"PageLayout_container__x-9df"};